import LocalStorage from './local';

export default class Preferences {

    static Get(key) {
        return JSON.parse(LocalStorage.get(`preference_${key}`));
    }
    static Set(key, value) {
        LocalStorage.set(`preference_${key}`, JSON.stringify(value));
    }
}